import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


interface AccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  generatedIdentifier: string;
  customerId: string;
}

const AccessModal: React.FC<AccessModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  generatedIdentifier,
  customerId,
}) => {
  const [error, setError] = useState<string | null>(null);
  const [isSaving, setIsSaving] = useState(false); 
  const navigate = useNavigate(); 


  const handleConfirmClick = async () => {
    if (!customerId) {
      setError("Error: ID del cliente no está definido.");
      return;
    }
  
    setError(null);
    setIsSaving(true); 
  
    try {
      await onConfirm();
      navigate(`/customerDashboard/${customerId}`);
      localStorage.setItem("customerId", customerId);
    } catch (err) {
      console.error("Error en el proceso de confirmación:", err);
      setError("Ocurrió un error al guardar o verificar el cliente.");
    } finally {
      setIsSaving(false); 
    }
  };
 

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
        <h2 className="text-lg font-semibold mb-4">Confirmar Acción</h2>
        {generatedIdentifier && (
          <>
            <p>Tu contraseña de ingreso: <strong>{generatedIdentifier}</strong></p>
            <p>¡Guardala! Se pedirá para ingresar.</p>
          </>
        )}

        {!generatedIdentifier && (
            <p>Generando código de acceso...</p> 
        )}

        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            onClick={() => {
              onClose();
              window.location.href = '/';
            }}
            disabled={isSaving}
          >
            Cancelar
          </button>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            onClick={handleConfirmClick}
            disabled={isSaving || !generatedIdentifier}
          >
            {isSaving ? 'Guardando...' : 'Guardar e ingresar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessModal;